import src from "./user-square.svg"

const width = 16
const height = 16
export default { src, width, height }
